import type { IconName } from '../components/Icon';

/**
 * The purpose tiles.
 *
 * ⚠️ MIRRORED from api/src/services/visits.ts (PURPOSE_KEYS) and
 * api/src/routes/vendor.ts (PURPOSE_LABELS). This repo has no `shared`
 * workspace — deliberately, to dodge the type-only-at-runtime and stale
 * tsc --build traps that have bitten other modules — so these two lists are
 * kept in step by hand. Adding a tile means editing BOTH sides; the API
 * rejects an unknown purposeKey with 400, so a one-sided change fails loudly at
 * the first tap rather than silently storing junk.
 *
 * Order is the design's, read left-to-right in a 2-column grid.
 */
export interface Purpose {
  key: string;
  label: string;
  icon: IconName;
}

export const PURPOSES: Purpose[] = [
  { key: 'maintenance', label: 'Maintenance', icon: 'wrench' },
  { key: 'delivery', label: 'Delivery', icon: 'truck' },
  { key: 'inspection', label: 'Inspection', icon: 'clipboard-list' },
  { key: 'landscaping', label: 'Landscaping', icon: 'droplets' },
  { key: 'pest_control', label: 'Pest control', icon: 'shield-check' },
  { key: 'other', label: 'Other', icon: 'ellipsis' },
];

export const OTHER_KEY = 'other';
